const getInternalOrExternal = (item) => {
    const link = item?.link;

    if (link?.__typename === "ContentfulCollection") {
        return link.slug;
    }

    return (
        link &&
        (link.contentfulInternalLink && link.contentfulInternalLink.slug
            ? link.contentfulInternalLink.slug
            : link.query
            ? link.query
            : link.externalLink && link.externalLink)
    );
};
export { getInternalOrExternal };
